import type { ReactElement, SVGProps } from "react";

/** SpaceXAI — the official post-merger swoosh mark (July 2026 rebrand),
 *  captured verbatim from x.ai's own "Copy black SVG" affordance. Monochrome,
 *  inherits the light/dark text color like the OpenAI treatment. The mark is
 *  FLAT (759x290 viewBox): the svg box matches its true aspect so flex
 *  centering grips the ink, not a padded square. Callers that need a
 *  different size should pass both `width` and `height` (in the 759:290.2
 *  ratio) since the two can no longer be derived from a single `size` prop. */
export function XAILogo(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      width={16}
      height={Math.round((16 * 290.2) / 759)}
      viewBox="0 0 759 290.2"
      fill="currentColor"
      className="block text-[#0d0d0d] dark:text-[#ededed]"
      aria-hidden
      {...props}
    >
      <g transform="translate(-674.5,-388.5)">
        <path d="M1433.19 388.934C1345.69 396.068 1001.73 438.71 763.235 678.467H674.732L684.62 668.612C734.53 620.395 955.373 416.045 1433.19 388.668V388.934Z" />
        <path d="M1133.66 678.467H1064.29L927.618 578.979C940.213 571.058 952.888 563.515 965.603 556.33L1133.66 678.467Z" />
        <path d="M1022.8 678.468H953.463L932.43 663.169H814.998C823.265 655.828 831.635 648.702 840.092 641.784H902.996L870.444 618.106C882.079 609.448 893.843 601.155 905.701 593.211L1022.8 678.468Z" />
        <path d="M770.433 495.02L823.901 533.876C810.594 541.712 798.139 549.468 786.514 557.055L701.158 494.986L770.433 495.02Z" />
      </g>
    </svg>
  );
}
